import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import {
  H6,
  Portal,
  space,
  color,
  radius,
  device,
  transition,
} from '@ticketswap/solar'
import { useViewer } from '../ViewerContext'
import getConfig from 'next/config'
const { ADMIN_URL } = getConfig().publicRuntimeConfig

const Container = styled.div`
  background-color: ${color.space};
  border-radius: ${radius.md};
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: ${space[16]};
  margin: ${space[16]};

  @media ${device.tablet} {
    position: fixed;
    padding: ${space[24]};
    z-index: 9;
    bottom: 0;
    right: 0;
    margin-left: 0;
    margin-top: 0;
    margin-right: ${space[32]};
    margin-bottom: ${space[32]};
    width: ${224 / 16}rem;
  }
`

const StyledH6 = styled(H6)`
  color: white;

  @media ${device.tablet} {
    margin-bottom: ${space[4]};
  }
`

const Link = styled.a`
  color: ${color.spaceLight};
  transition: color ${transition};

  &:hover,
  &:focus {
    color: white;
  }
`

const AdminMenu = props => {
  const { viewer } = useViewer()

  if (!viewer?.isEmployee) return null

  return (
    <Portal>
      <Container>
        <StyledH6>Admin</StyledH6>
        <ul>
          {props.links.map(({ text, url }, i) => (
            <li key={i}>
              <Link href={`${ADMIN_URL}${url}`}>{text}</Link>
            </li>
          ))}
        </ul>
      </Container>
    </Portal>
  )
}

AdminMenu.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
}

export default AdminMenu
